import FigmaDataIcon from './FigmaDataIcon';

interface Properties {
  width?: number;
  height?: number;
}

const ImportDataIcon = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaDataIcon width={width} height={height} color='#121826' />;
};

export default ImportDataIcon;
